<template>
    <div>
      <trademark-objection-to-us-status-list></trademark-objection-to-us-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  